import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Share2 } from "lucide-react";
import { renderResultCard } from "@/lib/resultCard";
import { SITE } from "@/lib/site";

const FILE = "money-passbook-result.png";

export const ShareCard = ({ result }) => {
  const [blob, setBlob] = useState(null);
  const [url, setUrl] = useState("");

  useEffect(() => {
    let objectUrl = "";
    renderResultCard(result, SITE).then((b) => {
      setBlob(b);
      objectUrl = URL.createObjectURL(b);
      setUrl(objectUrl);
    });
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, [result]);

  const download = () => {
    const a = document.createElement("a");
    a.href = url;
    a.download = FILE;
    a.click();
    toast.success("Card downloaded.");
  };

  const file = blob && new File([blob], FILE, { type: "image/png" });
  const canShare = !!(file && navigator.canShare && navigator.canShare({ files: [file] }));

  const share = async () => {
    try {
      await navigator.share({
        files: [file],
        title: "My Money Passbook result",
        text: `My Money Personality: ${result.personality} · Financial Well-Being Check ${result.score}/10`,
      });
    } catch (err) {
      if (err?.name !== "AbortError") toast.error("Sharing isn't available here — download the card instead.");
    }
  };

  return (
    <div className="grid gap-6 md:grid-cols-[220px_1fr] md:items-center" data-testid="quiz-share-card">
      <div className="aspect-[4/5] w-full max-w-[220px] overflow-hidden rounded-sm border border-border bg-primary shadow-[0_8px_30px_rgb(0,0,0,0.08)]">
        {url ? (
          <img src={url} alt="Your result card preview" className="h-full w-full object-cover" data-testid="quiz-share-preview" />
        ) : (
          <div className="flex h-full items-center justify-center text-xs text-primary-foreground/60">Preparing card...</div>
        )}
      </div>
      <div>
        <p className="text-sm font-semibold text-primary">Save or share your result card</p>
        <p className="mt-1 text-sm text-foreground/65">
          A portrait image with your personality, score and next action — sized for stories, WhatsApp or a
          team Slack. Nothing personal is included.
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <button
            onClick={download}
            disabled={!url}
            data-testid="quiz-download-card-btn"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.02] disabled:opacity-60"
          >
            <Download size={16} /> Download card
          </button>
          {canShare && (
            <button
              onClick={share}
              data-testid="quiz-share-card-btn"
              className="inline-flex items-center gap-2 rounded-full border border-primary px-6 py-3 text-sm font-semibold text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
            >
              <Share2 size={16} /> Share
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
